import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbPopoverDirective } from '@nebular/theme';
import { getDocumentNumber } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../@core/service/tree.service';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { DocumentStatusData } from '../../../../@models/erp/compilationData';
import { EventService } from '../../../../@core/service/eventService';

@Component({
  selector: 'ngx-document-tree',
  templateUrl: './document-tree.component.html',
  styleUrls: ['./document-tree.component.scss'],
})
export class DocumentTreeComponent implements OnInit {

  @Input() compilation: CompilationModel;
  @Input() loadFromItems: boolean = false;
  @Output() show = new EventEmitter<CompilationModel>();
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  tree: any = [];

  constructor(private api: ApiService, private data: SharedDataService, private treeService: TreeService, private event: EventService) { }

  async ngOnInit() {
  }

  setTree() {
    let top = this.compilation;
    while (top.parent) {
      top = this.data.latestVersionItems.find(f => f.code === top.parent);
    }
    this.tree = this.loadFromItems ? this.treeFromItems(top) : this.getDisplayTree();
  }

  showDoc(item: CompilationModel) {
    if (this.compilation.issuer !== item.issuer) this.event.emitIssuerChange(item.issuer);
    this.show.emit(item);
  }

  hide() {
    this.popover.hide();
  }

  treeFromItems(top: CompilationModel) {
    const lines = [];
    const items = this.data.latestVersionItems;
    function addLine(doc: CompilationModel, level: number) {
      lines.push({
        model: doc,
        type: 'doc',
        space: Array(level).join('-'),
        name: getDocumentNumber(doc),
      })
      const children = items.filter(f => f.parent === doc.code);
      children.forEach((el: CompilationModel) => addLine(el, level+1));
    }
    addLine(top, 1);
    return lines;
  }

  getDisplayTree() {
    const lines = [];
    function addLine(subtree: any, level) {
      if (!subtree) return;
      const space = Array(level).join('-');
      lines.push({
        model: subtree.doc,
        type: 'doc',
        cancelled: subtree.doc.documentStatus === DocumentStatusData.get('cancelled').id,
        space: space,
        name:getDocumentNumber(subtree.doc),
      });
      if (subtree.associated) {
        if (subtree.associated.pfspos) for (const pfspo of subtree.associated.pfspos) {
          lines.push({
            model: pfspo.doc,
            type: 'pfspo',
            cancelled: pfspo.doc?.documentStatus === DocumentStatusData.get('cancelled').id,
            space: space,
            name: getDocumentNumber(pfspo.doc),
          });
        }
        if (subtree.associated.nrkgPfspc) {
          lines.push({
            model: subtree.associated.nrkgPfspc.doc,
            type: 'pfspc',
            cancelled: subtree.associated.nrkgPfspc.doc.documentStatus === DocumentStatusData.get('cancelled').id,
            space: space,
            name: getDocumentNumber(subtree.associated.nrkgPfspc.doc),
          });
        }
        if (subtree.associated.cs) {
          lines.push({
            model: subtree.associated.cs.doc,
            type: 'cs',
            cancelled: subtree.associated.cs.doc.documentStatus === DocumentStatusData.get('cancelled').id,
            space: space,
            name: getDocumentNumber(subtree.associated.cs.code),
          });
        }
      }
      if (subtree.children && subtree.children.length) for (const child of subtree.children) {
        addLine(child, level+1);
      }
    }
    addLine(this.treeService.withCancelledRoot, 1);

    return lines;
  }

}
